import axios from 'axios';

class AuthService {
  async login(user) {
    await axios.get(`${process.env.VUE_APP_BACKEND_URL}/sanctum/csrf-cookie`, {
      withCredentials: true
    });

    await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/sanctum-login`, {
      email: user.email || user.login,
      password: user.password
    }, {
      withCredentials: true
    });

    const { data } = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/sanctum-user`, { withCredentials: true });
    return data;
  }

  async logout() {
    try {
      await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/sanctum-logout`, {}, {
        withCredentials: true
      });
    } catch (e) {
      console.log(e);
    }
  }

  async me() {
    const { data } = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/sanctum-user`, { withCredentials: true });
    return data;
  }

  async register(user) {
    const { data } = await axios.post('/User', {
      firstname: user.firstname,
      lastname: user.lastname,
      name: user.name,
      email: user.email,
      role_id: user.role_id,
      phone: user.phone,
      category_id: user.category_id,
      password: user.password,
      recommender_email: user.recommender_email,
      recaptcha_token: user.recaptcha_token
    }, { withCredentials: true });

    return data;
  }
}

export default new AuthService();